import React, { useState } from "react";
import { useLocation } from "react-router-dom";

type TAppContext = {
  page: number;
  ready: boolean | number;
  setReady?: React.Dispatch<React.SetStateAction<boolean | number>>;
};

export const AppContext = React.createContext<TAppContext>({} as TAppContext);

export const Provider = (props: { children: React.ReactNode }) => {
  const [ready, setReady] = useState<TAppContext["ready"]>(false);
  const { pathname } = useLocation();
  const isHome = pathname.slice(1) === "" || !isNaN(Number(pathname.slice(1)));
  const page = isHome ? parseInt(pathname.slice(1)) || 0 : 0;
  return (
    <AppContext.Provider value={{ page, ready, setReady }}>
      {props.children}
    </AppContext.Provider>
  );
};
